import { Component, OnInit, Input, Output, EventEmitter, HostListener } from '@angular/core';

interface FilterOptionType {
  label: string;
  value: string|number;
}

@Component({
  selector: 'app-filter',
  templateUrl: './filter.component.html',
  styleUrls: ['./filter.component.less']
})
export class FilterComponent implements OnInit {
  @Input() title: string;
  @Input() options: FilterOptionType[];
  @Input() value: string;
  @Input() label: string;

  @Output() activated = new EventEmitter<Boolean>();
  @Output() selected = new EventEmitter<(Number|String)[]>();

  public selectedValue;
  public searchText = '';
  public active = false;
  public selection = [];
  public currentWidth: (number|undefined);
  public showMenu = false;

  constructor() { }

  ngOnInit() {
    this.resizedWindow(window);
  }

  // @HostListener('document:click', ['$event'])
  // public onClick(event: MouseEvent, targetElement: HTMLElement): void {
  //   console.log('here', this._elementRef.nativeElement, event.srcElement);
  //   console.log('here', this._elementRef.nativeElement.contains(event.srcElement));
  //   console.log('***********************************************')
  //   if (!targetElement) {
  //       return;
  //   }

  //   const clickedInside = this._elementRef.nativeElement.contains(targetElement);
  //   if (!clickedInside) {
  //       // this.clickOutside.emit(event);
  //   }
  // }

  @HostListener('window:resize', ['$event.currentTarget'])
  resizedWindow(event) {
      this.currentWidth = event.innerWidth;
  }

  selectFilter() {
    this.active = !this.active;
    this.activated.emit(this.active);
  }

  selectAll() {
    if (this.selection.length === this.options.length) {
      this.selection = [];
    } else {
      for (const option of this.options) {
        this.selection.push(option[this.value]);
      }
    }
  }

  clearAll() {
    this.selection = [];
  }

  toggleSelection(fruitName) {
    const idx = this.selection.indexOf(fruitName);
    if (idx > -1) {
      this.selection.splice(idx, 1);
    } else {
      this.selection.push(fruitName);
    }
  }

  confirmSelection() {
    this.selected.emit(this.selection);
  }

  cancelSelection() {
    this.selection = [];
    this.selected.emit(this.selection);
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/emr-webapp/src/app/custom/admin-report/components/filter/filter.component.ts